import { Button } from 'react-bootstrap';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../app/store';
import { refreshToken } from '../signin/authSlice';

const RouteDebug = () => {
  const dispatch = useDispatch<AppDispatch>();

  const onClicked = () => {
    dispatch(refreshToken())
  }

  return (
    <>
      <Row>
        <Col>
          <Button variant="warning" onClick={onClicked}>Refresh token</Button>
        </Col>
      </Row>
    </>
  );
};

export default RouteDebug;
